import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService, LanguageService } from '../../shared/services/index';
import { InspectionPlugin } from '../../shared/models/index';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { AppLabels } from '../../utils/appLabels.class';
import { OfflineApiService } from '../../shared/services/offlineApi.service';

@Injectable()
export class TotalTimeToRepairPluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private offlineApiService: OfflineApiService,
    private inspectionFactory: InspectionFactoryService
  ) {
    super(apiService, dataService, offlineApiService, inspectionFactory);
  }

  public updateTotalTimeToRepair(inspectionId: string, pluginId: string, totalTimeToRepairs: any): Observable<any> {
    return this.update(inspectionId, pluginId, totalTimeToRepairs).pipe(
      map((res: InspectionPlugin) => {
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pluginId: string, totalTimeToRepairs: any): Observable<any> {
    return this.inspectionFactory
      .updatePluginConfig(inspectionId, null, pluginId, totalTimeToRepairs, 'TotalTimeToRepairs')
      .pipe(
        flatMap((plugin) => {
          if (this.isInspectionInOffline(inspectionId)) {
            return of(plugin);
          }
          return this.apiService.post(plugin.postServerUrl, plugin.config);
        })
      );
  }

  public sumTimeToRepairs(inspectionId: string): Observable<any[]> {
    return this.dataService.getInspectionPoints(inspectionId).pipe(
      map((points: any[]) => {
        const result = [];
        points.forEach((point) => {
          point.plugins
            .filter((p) => p.pluginType === 'timetorepair')
            .forEach((plugin) => {
              plugin.config.TimeToRepairs.filter(
                (ttr) => ttr.Reparator >= 0 && (ttr.Hours > 0 || ttr.Minutes > 0)
              ).forEach((ttr) => {
                if (!result[ttr.Reparator]) {
                  result[ttr.Reparator] = { Hours: 0, Minutes: 0, Reparator: ttr.Reparator };
                }
                if (ttr.Hours) {
                  result[ttr.Reparator].Hours += ttr.Hours;
                }
                if (ttr.Minutes) {
                  result[ttr.Reparator].Minutes += ttr.Minutes;
                }
              });
            });
        });
        return result
          .filter((r) => r)
          .map((ttr) => {
            ttr.Hours += Math.floor(ttr.Minutes / 60);
            ttr.Minutes = ttr.Minutes % 60;
            return ttr;
          });
      })
    );
  }
}
